import API from '../api.js';
import {parseZodSchema} from '@/api/models/parseZodSchema';
import {ssoTokenResponseModel} from '@/api/models/authentication/tokenResponse';

export default () => ({
    // redirectUri with a null value defaults in the backend
    async handleLogin(code: string, type: 'google', redirectUri: string | null) {
        return await API.postJSON(
            '/api/sso/handle-login',
            {
                code,
                type,
                redirectUri,
            },
            false
        )
            .then(API.handle)
            .catch(API.error)
            .then(raw => parseZodSchema(raw, ssoTokenResponseModel));
    },
});
